import {ProductGenqlSelection} from "@/gql/gen";

export const ProductFields: ProductGenqlSelection = {
    "ID": true,
    "NAME": true,
    "ACTIVE": true,
    "ACTIVE_FROM": true,
    "IBLOCK_CODE": true,
    "IBLOCK_ID": true,
    "IBLOCK_SECTION_ID": true,
    "IBLOCK_SECTION_IDS": true,
    "SALES_COUNT": true,
    "HIT_POSITION": true,
    "HIT_SECTION_POSITION": true,
    "CODE": true,
    "IMAGE": {
        "__fragment": "Image"
    },
    "DETAIL_TEXT": true,
    "IS_SALE_SPECIAL": true,
    "MEASURE": {
        "__fragment": "ProductMeasure"
    },
    "PREVIEW_TEXT": true,
    "PRICE": {
        "__fragment": "ProductPrice"
    },
    "SORT": true,
    "URL": true,
    "WEIGHT": true,
    "PROPERTIES": {
        __fragment: 'ProductPropsFields',
    },
    "INGREDIENTS": {
        ELEMENT_ID: true,
        IS_REMOVABLE: true,
    },
    "FEATURE_IDS": true,
}
